function isValidDate(d: string | Date | number): boolean {
  return d instanceof Date && !Number.isNaN(d)
}

export default isValidDate
